import { render, staticRenderFns } from "./OverviewSources.vue?vue&type=template&id=206f5d64&scoped=true&"
import script from "./OverviewSources.vue?vue&type=script&lang=js&"
export * from "./OverviewSources.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSources.vue?vue&type=style&index=0&id=206f5d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f5d64",
  null
  
)

export default component.exports